import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.esm.js';
import { reactNodeToString, isTextTruncated } from '@costar-ui/utils';
import { useRef, useMemo, useState, useCallback } from 'react';

function useTextEllipsisState(ellipsis, children, _title, shouldShowHoverTitle) {
  var shouldTruncated = !!ellipsis;
  var localRef = useRef(null);
  var title = useMemo(function () {
    return shouldShowHoverTitle ? (_title !== null && _title !== void 0 ? _title : shouldTruncated) ? "".concat(reactNodeToString(children)) : '' : '';
  }, [_title, shouldTruncated, children, shouldShowHoverTitle]);

  // Define state and function to update the value
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTitle = _useState2[0],
    setShowTitle = _useState2[1];
  var handleOnMouseOver = useCallback(function () {
    if (shouldShowHoverTitle) {
      var isSingleLine = ellipsis === '1';
      var _showTitle = !!localRef.current && isTextTruncated(localRef.current, isSingleLine);
      setShowTitle(_showTitle);
    }
  }, [shouldShowHoverTitle, ellipsis]);
  return {
    localRef: localRef,
    showTitle: showTitle,
    title: title,
    handleOnMouseOver: handleOnMouseOver
  };
}

export { useTextEllipsisState as default };
//# sourceMappingURL=use-text-ellipsis-state.esm.js.map
